export const headers = () => {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("webApiAccessToken"),
      //  "X-Correlation-Id": correlationId
    },
  };
};

export const headersCorrelated = (correlationId: string) => {
  return {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("webApiAccessToken"),
      "X-Correlation-Id": correlationId,
    },
  };
};
